// extracted by mini-css-extract-plugin
export var background = "topTextImage-module--background--JTUZB";
export var firstImage = "topTextImage-module--firstImage--Uzmte";
export var heading = "topTextImage-module--heading--gkkkm";
export var subheading = "topTextImage-module--subheading--bOfni";
export var top = "topTextImage-module--top--vk-B3";